<template>
  <div class="form tab-content" style="min-height: 200px">
    <v-layout style="width: 100%; max-height: 65vh;">
      <asset-selection
        v-if="canAddAssets"
        :template="template"
        :filters="filters"
        :asset-reservation-objects="assets"
        :layers-to-show="layersToShow"
        :only-used-elements="onlyUsedElements"
      />

      <v-divider vertical v-if="canAddAssets" />

      <selected-assets
        tab="assets"
        :action-type="actionType"
        :asset-reservation-objects="assets"
        :user-can-add-objects="canAddAssets"
        @update-asset-reservation-objects="$emit('update-assets', $event)"
        :key="assets.length"
        @add-asset-to-delete="addAssetToDelete"
      />
    </v-layout>
  </div>
</template>

<script>
import MultipleObjectsMultipleLayersTable from "@/components/Home/Forms/_Organisms/MultipleObjectsMultipleLayersTable";
import AssetSelection from "@/components/Home/Forms/_SpecialTabs/AssetReservationForm/AssetsTab/AssetSelection";
import SelectedAssets from "@/components/Home/Forms/_SpecialTabs/AssetReservationForm/AssetsTab/SelectedAssetReservationObjects";

export default {
  name: "AssetReservationFormAssetsTab",

  components: {
    SelectedAssets,
    AssetSelection,
    MultipleObjectsMultipleLayersTable
  },

  props: {
    disabled: {
      type: Boolean
    },

    actionType: {
      type: String,
      required: true
    },

    template: {
      type: Object
    },

    assets: {
      type: Array
    },

    /**
     * Indicates if only used assets should be listed
     */
    onlyUsedElements: {
      type: Boolean
    },

  },

  computed: {
    /**
     * Indicates if assets can be added
     * @returns {Boolean} indicating if assets can be added
     */
    canAddAssets() {
      return (
        this.actionType === "create" ||
        this.actionType === "addAssetsToReservation" ||
        this.actionType === "createAssetReservation"
      );
    },

    /**
     * Returns the filters for the asset selection
     * @returns {Array} filters for asset select
     */
    filters() {
      return [
        {
          field: "owner",
          value: this.template.art_owner_id ? this.template.art_owner_id : ""
        },
        {
          field: "progress",
          value: this.template.art_status ? this.template.art_status : "U,E"
        }
      ];
    },

    /**
     * Indicates which layers can be shown
     * @returns {Array} the layers to be shown
     */
    layersToShow() {
      let layersToShow = [];
      if (this.template) {
        let possibleLayers = this.template.art_accepted_layers;
        let validLayers = this.$store.getters
          .getValidAssetReservationObjectLayersInArea;

        if (possibleLayers === "all") {
          layersToShow = validLayers;
        } else {
          layersToShow = validLayers.filter(layer =>
            possibleLayers.includes(layer)
          );
        }
      }
      return layersToShow;
    }
  },
  methods:{
    addAssetToDelete(object){
      this.$emit('add-asset-to-delete', object);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/AssetReservationForm/AssetsTab.vue